import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LegalPage.css';

const TermsOfUsePage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <div className="legal-container">
        <button className="legal-back" onClick={() => navigate(-1)}>
          <i className="ri-arrow-left-line" /> Назад
        </button>

        <h1 className="legal-title">Условия использования (бета-версия)</h1>
        <p className="legal-updated">Действует с 4 июля 2026 года · Ryaskov.pro</p>

        <div className="legal-content">
          <div className="legal-highlight">
            <p>
              Сервис Ryaskov.pro находится в стадии <strong>бета-тестирования</strong>.
              Пожалуйста, внимательно ознакомьтесь с условиями ниже перед использованием —
              они описывают ограничения и риски, связанные с текущим статусом Сервиса.
            </p>
          </div>

          <h2>1. Статус сервиса</h2>
          <p>
            Ryaskov.pro (далее — «Сервис») является программным продуктом на стадии активной
            разработки и бета-тестирования. Это означает, что функциональность Сервиса
            не является окончательной, продолжает изменяться и может содержать ошибки.
          </p>

          <h2>2. Возможные ошибки и их последствия</h2>
          <p>Используя Сервис на стадии бета-тестирования, вы понимаете и соглашаетесь, что:</p>
          <ul>
            <li>
              в работе Сервиса могут встречаться программные ошибки (баги), в том числе
              влияющие на корректность отображаемой информации;
            </li>
            <li>
              <strong>расчёты сумм, ставок, часов, балансов, начислений и иных финансовых
              показателей могут содержать неточности</strong> из-за ошибок в логике расчёта,
              округления или синхронизации данных;
            </li>
            <li>
              возможны сбои сохранения, отображения или синхронизации данных между
              устройствами и пользователями;
            </li>
            <li>
              возможны временные перебои в работе Сервиса, включая полную недоступность,
              связанные с обновлениями, техническими работами или сбоями инфраструктуры;
            </li>
            <li>
              возможна потеря или повреждение данных, внесённых в Сервис, в результате
              программных ошибок, сбоев базы данных или иных технических причин;
            </li>
            <li>
              интерфейс, функциональность и структура данных Сервиса могут изменяться
              без предварительного уведомления.
            </li>
          </ul>

          <h2>3. Рекомендации по использованию</h2>
          <p>
            В связи со статусом бета-тестирования настоятельно рекомендуется:
          </p>
          <ul>
            <li>
              самостоятельно проверять важные финансовые расчёты (суммы к оплате, балансы,
              начисления) перед принятием решений на их основе;
            </li>
            <li>
              не использовать Сервис как единственный источник учёта критически важных
              данных без параллельного ведения резервного учёта;
            </li>
            <li>сообщать о найденных ошибках для их оперативного устранения.</li>
          </ul>

          <h2>4. Ограничение ответственности</h2>
          <p>
            Сервис предоставляется «как есть» (as is), без каких-либо гарантий, явных или
            подразумеваемых, включая гарантии точности расчётов, бесперебойной работы,
            сохранности данных или пригодности для конкретных целей.
          </p>
          <p>
            В максимально допустимой законодательством РФ степени Оператор Сервиса
            не несёт ответственности за:
          </p>
          <ul>
            <li>
              любые прямые или косвенные убытки, возникшие в результате использования
              Сервиса, включая финансовые потери из-за ошибок в расчётах;
            </li>
            <li>потерю данных, внесённых пользователем в Сервис;</li>
            <li>
              решения, принятые пользователем на основании данных, полученных из Сервиса,
              без их самостоятельной проверки;
            </li>
            <li>перерывы в доступности Сервиса.</li>
          </ul>

          <h2>5. Изменение условий</h2>
          <p>
            Оператор вправе изменять настоящие условия по мере развития Сервиса.
            Актуальная версия условий всегда доступна по этой ссылке.
          </p>

          <h2>6. Обратная связь</h2>
          <p>
            Если вы обнаружили ошибку в работе Сервиса или расчётах — сообщите об этом
            по адресу <strong>mail@ryaskov.pro</strong>. Это поможет сделать Сервис лучше.
          </p>

          <div className="legal-highlight">
            <p>
              Регистрируясь в Сервисе, вы подтверждаете, что ознакомлены с текущим
              бета-статусом Сервиса, связанными с ним рисками и принимаете настоящие условия.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfUsePage;
